import * as bootstrap from "bootstrap";
// Expose the namespace so dual-rendered chrome can feature-detect BS5's
// presence (the legacy.js entrypoint, used on BS2.3 pages, omits Bootstrap).
// e.g. offcanvas_toggler_controller falls back to a vanilla drawer when absent.
window.bootstrap = bootstrap;

import Rails from "@rails/ujs";

Rails.start();

import "/custom/clients";

import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";

const app = Application.start();

const controllers = import.meta.glob("../controllers/**/*_controller.js", { eager: true });
registerControllers(app, controllers);

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
